var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembersactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.15,
    height: 23.65,
    viewBox: "0 0 25.15 23.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M192,482.87c.051-.179.106-.358.152-.539a5.344,5.344,0,0,1,9.986-1.082c.083.166.16.334.236.493,2.5-.461,2.5-.461,4.363.013.064-.11.141-.226.2-.351a5.336,5.336,0,0,1,10.2,2.251c.018,2.136.007,4.273,0,6.409,0,.762-.252,1.019-1.015,1.023-1.8.009-3.6,0-5.4,0h-.8c0,.686,0,1.323,0,1.96-.007.929-.22,1.139-1.156,1.14q-4.21,0-8.42,0c-.892,0-1.121-.224-1.128-1.1-.006-.643,0-1.286,0-2h-2.46c-1.173,0-2.348.037-3.518-.02a4.849,4.849,0,0,1-1.241-.407Q192,486.767,192,482.87Zm8.813,9.713h7.523c0-2.1.063-4.148-.018-6.193a3.756,3.756,0,0,0-7.483-.065C200.739,488.389,200.813,490.462,200.813,492.583Zm14.676-3.087c0-2.25.123-4.493-.042-6.715a3.5,3.5,0,0,0-3.252-2.928,3.651,3.651,0,0,0-3.856,2.393.848.848,0,0,0,.066.717,5.7,5.7,0,0,1,1.522,4.256c-.021.747,0,1.5,0,2.276Zm-21.925-.009h5.654c0-.9,0-1.756,0-2.613a5.58,5.58,0,0,1,1.451-3.843.9.9,0,0,0,.141-.752,3.714,3.714,0,0,0-7.181.844c-.1,1.543-.051,3.1-.064,4.646C193.56,488.33,193.564,488.892,193.564,489.486Z",
    transform: "translate(-192 -470.542)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M210.824,416.953a3.4,3.4,0,1,1-3.4,3.39A3.43,3.43,0,0,1,210.824,416.953Zm1.83,3.428A1.828,1.828,0,1,0,210.8,422.2,1.82,1.82,0,0,0,212.654,420.381Z",
    transform: "translate(-205.481 -416.953)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M325.609,423.763a3.4,3.4,0,1,1,3.5-3.356A3.43,3.43,0,0,1,325.609,423.763Zm.063-5.241a1.841,1.841,0,1,0,1.859,1.811A1.821,1.821,0,0,0,325.673,418.523Z",
    transform: "translate(-305.904 -416.961)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M271.742,445.013a3.4,3.4,0,0,1-6.8.035,3.4,3.4,0,1,1,6.8-.035Zm-3.418,1.826a1.811,1.811,0,0,0,1.856-1.806A1.84,1.84,0,0,0,266.5,445,1.813,1.813,0,0,0,268.323,446.839Z",
    transform: "translate(-255.769 -438.515)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersactive);
export default __webpack_public_path__ + "static/media/membersactive.5efbfbd2f5801cf64e18942366942924.svg";
export { ForwardRef as ReactComponent };